<template>

	<div class="w-full">

		<div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6">
			<div class="px-6 py-4 w-full md:w-auto -mb-3 md:mb-0">
				Quick Actions
			</div>
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<router-link tag="button" to="/admin/tools/email-generator" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Email Generator
				</router-link>
				<router-link tag="button" to="/admin/tools/announcements" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Announcement Generator
				</router-link>
				<router-link tag="button" to="/admin/sales/pending" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Pending Sales
				</router-link>
				<router-link tag="button" to="/admin/sales/processing" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Processing Sales
				</router-link>
				<router-link tag="button" to="/media/latest" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Media Panel
				</router-link>
			</div>
		</div>

        <!-- chasers -->
        <div class="flex flex-wrap -mx-3">
			<Card class="w-full mb-6 px-3">
				<template v-slot:header>
					Upcoming Videos
					<span class="absolute top-0 right-0 px-2 py-1 mt-3 mr-3 text-gray-500 opacity-0 group-hover:opacity-100 transition-default transition-all cursor-pointer" v-on:click="getUpcomingVideos()">
						<i class="fas fa-sync"></i>
					</span>
				</template>
				<template v-slot:body>

					<CustomTable v-if="upcoming.uploading.length == 0 && upcoming.processing.length == 0 && upcoming.pending.length == 0">
						<template v-slot:body>
							<tr class="text-center">
								<td colspan="4" class="py-5">There are no videos currently upcoming.</td>
							</tr>
						</template>
					</CustomTable>

					<CustomTable v-if="upcoming.uploading.length !== 0">
						<template v-slot:body>
							<tr class="text-left">
								<td colspan="4" class="px-6 py-2 font-bold bg-gray-100">Uploading</td>
							</tr>
							<tr v-for="video in upcoming.uploading">
								<td class="py-4 px-6 border-b border-grey-light">{{ video.user.name }}</td>
								<td class="py-4 px-6 border-b border-grey-light">{{ video.title }}</td>
								<td class="py-4 px-6 border-b border-grey-light">
									<div class="shadow w-full bg-grey-200 rounded" style="min-width: 200px;">
										<div class="text-xs leading-none py-1 text-center text-white rounded" :class="{'bg-blue-600': video.status == 'uploading', 'bg-yellow-500': video.status == 'upload_paused'}" style="width: 45%">45%</div>
									</div>
								</td>
								<td class="py-4 px-3 border-b border-grey-light">
									<button class="bg-red-700 px-2 py-1 text-white text-xs rounded" v-on:click="removeUpload(video.id)" v-if="canBeDeleted(video.updated_at)">
										<span class="fa fa-trash"></span>
									</button>
								</td>
							</tr>
						</template>
					</CustomTable>
					
					<CustomTable v-if="upcoming.processing.length !== 0">
						<template v-slot:body>
							<tr class="text-left">
								<td colspan="4" class="px-6 py-2 font-bold bg-gray-100">Processing</td>
							</tr>
							<tr v-for="video in upcoming.processing">
								<td class="py-4 px-6 border-b border-grey-light">{{ video.user.name }}</td>
								<td class="py-4 px-6 border-b border-grey-light">{{ video.title }}</td>

								<td class="py-4 px-6 border-b border-grey-light text-right">
									{{ video.status | displayProgress }}

									<button class="bg-blue-700 px-2 py-1 text-white text-xs rounded ml-2" v-if="video.status == 'yt_uploading' && canBeDeleted(video.updated_at)" v-on:click="reuploadToYouTube(video.id)">
										<span class="fa fa-redo"></span>
									</button>
									<button class="bg-blue-700 px-2 py-1 text-white text-xs rounded ml-2" v-if="video.status == 'aws_trans' && canBeDeleted(video.updated_at)" v-on:click="reProcess(video.id)">
										<span class="fa fa-redo"></span>
									</button>
									<button class="bg-red-700 px-2 py-1 text-white text-xs rounded ml-2" v-on:click="removeUpload(video.id)" v-if="canBeDeleted(video.updated_at)">
										<span class="fa fa-trash"></span>
									</button>
								</td>
							</tr>
						</template>
					</CustomTable>

					<CustomTable v-if="upcoming.pending.length !== 0">
						<template v-slot:body>
							<tr class="text-left">
								<td colspan="4" class="px-6 py-2 font-bold bg-gray-100">Pending</td>
							</tr>
							<tr v-for="video in upcoming.pending">
								<td class="py-4 px-6 border-b border-grey-light w-48">
									<progressive-img fallback="/static/image-unavailable.png" :src="video.thumbnailUrl "/>
								</td>
								<td class="py-4 px-6 border-b border-grey-light">
									<strong>{{ video.title }}</strong> <br/>
									{{ video.created_at | displayLocalDateTime }}<br/>
									{{ video.user.name }}
								</td>
								<td class="py-4 px-6 border-b border-grey-light text-right">
									<button class="bg-blue-700 px-2 py-1 rounded text-white mr-4" v-on:click="viewApprovalModal(video)" data-toggle="modal" data-target="#approveVideoModal">View</button>
									<button class="bg-red-700 px-2 py-1 rounded text-white" v-on:click="removeUpload(video.id)">Delete Video</button>
								</td>
							</tr>
							<tr class="bg-grey-lighter text-center" v-if="pollingUpcoming">
								<td class="py-5" colspan="4">
									<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
								</td>
							</tr>
						</template>
					</CustomTable>

					<CustomTable v-if="upcoming.errors.length !== 0">
						<template v-slot:body>
							<tr class="text-left">
								<td colspan="4" class="px-6 py-2 font-bold bg-red-100">Errors</td>
							</tr>
							<tr v-for="video in upcoming.errors">
								<td class="py-4 px-6 border-b border-grey-light">
									<strong>{{ video.title }}</strong> by {{ video.user.name }}<br/>
									{{ video.created_at | displayLocalDateTime }}<br/>
									

									<div class="w-full mt-4" v-for="history in errorHistory(video.history)">
										<span class="text-red-600 font-semibold">{{ history.meta.error }}</span>
									</div>
								</td>
								<td class="py-4 px-6 border-b border-grey-light text-right">
									<button class="bg-red-700 px-2 py-1 rounded text-white" v-on:click="removeUpload(video.id)">Remove</button>
								</td>
							</tr>
							<tr class="bg-grey-lighter text-center" v-if="pollingUpcoming">
								<td class="py-5" colspan="4">
									<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
								</td>
							</tr>
						</template>
					</CustomTable>
				</template>
			</Card>

			<Card class="w-full mb-6 lg:w-1/2 lg:mb-0 px-3">
				<template v-slot:header>
					Sales
					<router-link class="absolute top-0 right-0 px-2 py-1 mt-3 mr-3 text-gray-500 opacity-0 group-hover:opacity-100 transition-default transition-all" :to="{ name: ''}" >
						<i class="fas fa-arrow-circle-right"></i>
					</router-link>
				</template>
				<template v-slot:body>
					<canvas id="salesChart" class="p-3"></canvas>
				</template>
			</Card>

			<Card class="w-full mb-6 lg:w-1/2 px-3">
				<template v-slot:header>
					Active Users
					<router-link class="absolute top-0 right-0 px-2 py-1 mt-3 mr-3 text-gray-500 opacity-0 group-hover:opacity-100 transition-default transition-all" :to="{ name: ''}" >
						<i class="fas fa-arrow-circle-right"></i>
					</router-link>
				</template>
				<template v-slot:body>
					<CustomTable>
						<template v-slot:header>
							<th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
							<th class="py-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Name</th>
							<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Permission</th>
							<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Last Active</th>
						</template>
						<template v-slot:body>
							<tr class="hover:bg-grey-lighter" v-for="user in users" v-if="!polling">
								<td class="py-4 pl-6 border-b border-grey-light">
									<span class="w-2 h-2 rounded-full bg-yellow-600 inline-block cursor-pointer" v-if="determineIsIdle(user.last_active)" title="Idle" v-tippy></span>
									<span class="w-2 h-2 rounded-full bg-green-600 inline-block cursor-pointer" v-if="!determineIsIdle(user.last_active)" title="Active" v-tippy></span>
								</td>
								<td class="py-4 border-b border-grey-light pl-2"><router-link :to="{ name: 'AdminUserDetails', params: { id: user.user_id }}" class="text-blue-600">{{ user.name }}</router-link></td>
								<td class="py-4 px-6 border-b border-grey-light">{{ user.role | displayRole}}</td>
								<td class="py-4 px-6 border-b border-grey-light">{{ user.last_active | timeAgo }}</td>
							</tr>
							<tr class="bg-grey-lighter text-center" v-if="polling">
								<td class="py-5" colspan="4">
									<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
								</td>
							</tr>
						</template>
					</CustomTable>
				</template>
			</Card>
        </div>

		<approve-video-modal></approve-video-modal>

    </div>
</template>

<script>

	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';
	import { EventBus } from '@/utils/events';
    import moment from 'moment';
	import Chart from 'chart.js';
	import _ from 'lodash'
	import download from 'downloadjs'

	import CustomTable from '@/components/general/CustomTable'
	import Card from '@/components/partials/Card'
	import ApproveVideoModal from './modals/ApproveVideoModal'


	export default {
		name: 'HelloWorld',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App',
				graphData: null,
				chart: null,
				canvas: null,
				content: null,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				view: {
					param: 'week',
					title: 'Week',
				},
				loadingReport: false,

				users: [],
				refreshInterval: null,
				version: 'loading...',
				polling: true,
				pollingUpcoming: true,
				upcoming: {
					uploading: [],
					processing: [],
					pending: [],
					errors: []
				},
			}
		},
		components: {
			CustomTable,
			Card,
			ApproveVideoModal
		},
		mounted() {
			this.canvas = document.getElementById('salesChart')
			this.context = this.canvas.getContext('2d')
		
			this.getSalesGraphData();
			this.getUpcomingVideos();

			this.getUsers();
			this.loadVersion();
            
			this.refreshInterval = setInterval(function () {
				this.getUsers();
				this.getUpcomingVideos();
			}.bind(this), 30000);
			
			this.$nextTick(function () {
                EventBus.$on('admin-approve-video-refresh-data', this.getUpcomingVideos);
            }.bind(this));
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
			]),
			
			getSalesGraphData() {
				return this.$http.get(Config.apiPath + "/api/v2/admin/graphs/sales", {
					headers: this.getAuthorizationHeader()['headers'],
					params: {
						filter: this.view.param,
						timezone: this.timezone,
					}
				}).then((response) => {
					this.graphData = response.data
					this.createSalesGraph();
                });
			},

			changeView (param, title) {
				// Don't reload the same view.
				if (this.view.param === param) return
				this.view = {
					param: param,
					title: title
				}
				this.getSalesGraphData().then(this.updateChart)
			},

			createSalesGraph() {

				if (this.chart !== null) {
					this.chart.destroy()
				}

				var data_keys = _.keys(this.graphData);
				if (0 < data_keys.length && data_keys[0].length > 10) {
					for (var i = 0; i < data_keys.length; i++) {
						data_keys[i] = data_keys[i].substr(11);
					}
				}

				this.chart = new Chart(this.context, {
					type: 'line',
					data: {
						labels: data_keys,
						datasets: [{
							data: _.values(this.graphData),
							backgroundColor: 'rgba(0,85,161,0.4)',
							borderColor: 'rgba(0,85,161,0.6)',
							// borderColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointBackgroundColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointBorderColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointHoverBackgroundColor: "{{ color_darken($theme_metrics, -0.2) }}",
							// pointHoverBorderColor: "{{ color_darken($theme_metrics, -0.2) }}"
						}]
					},
					options: {
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									if(tooltipItem.yLabel == 1) {
										return tooltipItem.yLabel + " sale";
									}
									return tooltipItem.yLabel + " sales";	
								}
							}
						},
						legend: {
							display: false
						},
				}})
			
			},


			getUsers() {
				var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/users/active", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'users', response.data)
                    this.$set(this, 'polling', false)
                });
			},
			determineIsIdle(time) {
				var date1 = moment.utc(new Date()).format("YYYY-MM-DD HH:mm:ss");
				// console.log(date1)
				var date2 = moment(time);
				// console.log(date2)
				var diff = date2.diff(date1, 'minutes');

				// console.log(Math.abs(diff))

				if(Math.abs(diff) > 5) {
					return true;
				}
				return false;
			},

			loadVersion() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/utilities/versions/current", this.getAuthorizationHeader()).then((response) => {
                    _this.version = response.data
                });
            },
			getUpcomingVideos() {
                this.$http.get(Config.apiPath + "/api/v2/admin/videos/upcoming", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'upcoming', response.data)
                    this.$set(this, 'pollingUpcoming', false)
                });
			},
			
			viewApprovalModal(video) {
                EventBus.$emit('admin-approve-video-open-modal', video);
            },
            determineProgress(status) {
                if(status == 'trf_aws') {
                    return '25%'
                }
                if(status == 'aws_trans') {
                    return '50%'
                }
                if(status == 'yt_uploading') {
                    return '75%'
                }
                if(status == 'yt_process') {
                    return '100%'
                }
            },

            removeUpload(id) {

                this.$swal({
                    title: 'Continue?',
                    text: "Are you sure you want to remove this upload?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, remove upload.'
                }).then((result) => {
                    if (result.value) {

                        var data = {
                            id: id,
                        }

                        var _this = this;
                        this.$http.post(Config.apiPath + "/api/v2/admin/videos/remove", data, this.getAuthorizationHeader()).then((response) => {
                            if(response.status == 200) {

                                _this.getUpcomingVideos();

                            }
                        });

                    }

                });                

			},
			
			reuploadToYouTube(id) {
				this.$http.post(Config.apiPath + "/api/v2/admin/videos/" + id + "/youtube_upload", {}, this.getAuthorizationHeader()).then((response) => {
					if(response.status == 200) {
						console.log('ok')
					}
				});
			},

			reProcess(id) {
				this.$http.post(Config.apiPath + "/api/v2/admin/videos/" + id + "/reprocess", {}, this.getAuthorizationHeader()).then((response) => {
					if(response.status == 200) {
						console.log('ok')
					}
				});
			},

            canBeDeleted(updated_at) {

                var update = moment.utc(updated_at)
                var now = moment.utc(new Date())

                if(Math.abs(update.diff(now, 'minutes')) > 10) {
                    return true
                }

                return false

			},
			errorHistory: function(videoHistoryArr) {
				console.log(videoHistoryArr)
				return videoHistoryArr.filter((row) => {
					return row.type == 'VideoProcessingFailed'
				})
			}
			
		},
		beforeDestroy: function() {
            clearInterval(this.refreshInterval);
        },

		filters: {
			displayRole: function(data) {
				if(data == 'videographer') {
					return 'Videographer'
				} else if (data == 'media_purchaser') {
					return 'Media Purchaser'
				} else if (data == 'media_producer') {
					return 'Media Producer'
				} else if (data == 'administrator') {
					return 'Administrator'
				} else if (data == 'superadministrator') {
					return 'Super Administrator'
				}
			},
			timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
			displayLocalDate: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY');
            },
			displayLocalTime: function(date) {
                return moment.utc(date).local().format('h:mm A');
			},
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            },
            displayProgress: function(value) {
                if(value == 'trf_aws') {
                    return 'Transferring video to AWS for transcoding.'
                }
                if(value == 'aws_trans') {
                    return 'AWS is currently transcoding this video.'
                }
                if(value == 'yt_uploading') {
                    return 'Uploading video to YouTube.'
                }
                if(value == 'yt_process') {
                    return 'YouTube is currently processing this video.'
                }
            }
		}
       
	}
</script>